export const CARRIER_BLACKLIST_REPORT_CHANGE_TRACKING = {
  removeCarrier: {
    source: 'carrier_blacklist_report.remove_carrier',
    id: 12445,
  },
} as const;
